<template>
    <div
        class="quickpay-payment-overview-description"
        :class="{ 'quickpay-payment-overview-description--centered': type === 'error' }"
    >
        <img :src="iconPath" :alt="title" class="quickpay-payment-overview-description__icon" />
        <h1 class="quickpay-payment-overview-description__title">
            {{ title }}
        </h1>
        <p
            v-if="description"
            class="quickpay-payment-overview-description__description typographies-paragraph-large-regular"
        >
            {{ description }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
            validator: (value) => ['payment', 'payment_success', 'error'].includes(value),
        },
        data: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            translations: {
                payment: {
                    title: this.$t.__('quickpay.QuickpayPaymentOverviewDescription.payment.title'),
                    description: this.$t.__(
                        'quickpay.QuickpayPaymentOverviewDescription.payment.description',
                    ),
                },
                paymentSuccess: {
                    title: this.$t.__(
                        'quickpay.QuickpayPaymentOverviewDescription.payment_success.title',
                    ),
                },
                paymentProcessing: {
                    title: this.$t.__(
                        'quickpay.QuickpayPaymentOverviewDescription.payment_processing.title',
                    ),
                },
                error: {
                    title: this.$t.__('quickpay.QuickpayPaymentOverviewDescription.error.title'),
                    description: this.$t.__(
                        'quickpay.QuickpayPaymentOverviewDescription.error.description',
                    ),
                },
            },
        };
    },
    computed: {
        isProcessing() {
            return this.data?.payment_success?.processing === true;
        },
        iconPath() {
            if (this.type === 'payment_success' && this.isProcessing) {
                return '/ressources/logged/img/illustrations/payment/clock.svg';
            }
            switch (this.type) {
                case 'payment':
                    return '/ressources/logged/img/illustrations/payment/lock.svg';
                case 'payment_success':
                    return '/ressources/logged/img/illustrations/payment/success-circle.svg';
                case 'error':
                    return '/ressources/logged/img/illustrations/payment/file-alert.svg';
                default:
                    return '';
            }
        },
        title() {
            if (this.type === 'payment_success' && this.isProcessing) {
                return this.translations.paymentProcessing.title;
            }
            switch (this.type) {
                case 'payment':
                    return this.translations.payment.title;
                case 'payment_success':
                    return this.translations.paymentSuccess.title;
                case 'error':
                    return this.translations.error.title;
                default:
                    return '';
            }
        },
        description() {
            switch (this.type) {
                case 'payment':
                    return this.translations.payment.description;
                case 'error':
                    return this.translations.error.description;
                default:
                    return '';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.quickpay-payment-overview-description {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-3);

    @media (max-width: 1023px) {
        align-items: flex-start;
        text-align: left;
    }

    &--centered {
        align-items: center;
        text-align: center;

        @media (max-width: 1023px) {
            align-items: center;
            text-align: center;
        }
    }

    &__icon {
        width: 44px;
        height: 44px;
    }

    &__title {
        margin: 0;
        color: var(--colors-common-text-brand-secondary-blue);
        font-family: Stack Sans Text;
        font-weight: 700;
        font-size: 38px;
        line-height: 45px;
    }

    &__description {
        margin: 0;
        color: var(--colors-common-text-subtle-default);
        font-weight: 500;
        font-size: 18px;
        line-height: 28px;
    }
}
</style>
